import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  AppointmentAvailability,
  AppointmentDayAvailability,
  AppointmentPreselection,
  AppointmentSlot,
  BookingConfirmation,
  ConsentState,
  PatientDetails,
  SmsMetaResponse,
  SmsSendResponse,
  SmsVerifyResponse
} from '../model/appointments-models';
import {AppointmentsApiService} from './appointments-api.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsController {
  constructor(private api: AppointmentsApiService) {
  }

  loadEntryConfig() {
    return this.api.getEntryConfig();
  }

  loadAvailability(preselection: AppointmentPreselection): Observable<AppointmentAvailability> {
    return this.api.getAvailability(preselection);
  }

  submitPatientDetails(
    preselection: AppointmentPreselection,
    selectedDay: AppointmentDayAvailability,
    selectedSlot: AppointmentSlot,
    details: PatientDetails,
    consents: ConsentState
  ): Observable<void> {
    return this.api.submitPatientDetails(preselection, selectedDay, selectedSlot, details, consents);
  }

  sendSmsCode(): Observable<SmsSendResponse> {
    return this.api.sendSmsCode();
  }

  verifySmsCode(code: string): Observable<SmsVerifyResponse> {
    return this.api.verifySmsCode(code);
  }

  confirmBooking(): Observable<BookingConfirmation> {
    return this.api.confirmBooking();
  }

  getSmsMeta(): Observable<SmsMetaResponse> {
    return this.api.getSmsMeta();
  }
}
